"use strict";

function parseOptions(opts, defaultLimit) {
  let r;

  if (typeof opts === 'number') {
    r = {
      limit: opts,
      handleReject: false
    };
  } else if (typeof opts === 'object') {
    r = {
      limit: defaultLimit,
      handleReject: false,
      ...opts
    };
  } else {
    r = {
      limit: defaultLimit,
      handleReject: false
    };
  }

  if (r.limit <= 0) {
    throw new Error('limit must be greater than zero');
  }

  return r;
}

module.exports = {
  parseOptions
};